export class SystemContants {
  static STATUS_SUCCESS: string = "success";
  static STATUS_FAILED: string = "success";
  static DELETE_YES_FLAG: number = 1;
  static DELETE_NOT_FLAG: number = 0;
  static STATUS_ENABLED: number = 1;
  static STATUS_DISABLED: number = 0;
  static DICT_ROOT_VIP_LEVEL: string = "1098464043821297666";
}

export function getStatus(status: number) {
  if (status === SystemContants.STATUS_ENABLED) {
    return "正常";
  } else if (status === SystemContants.STATUS_DISABLED) {
    return "不可用";
  } else {
    return "未知";
  }
}

export function getDeleteFlag(deleteFlag: number) {
  if (deleteFlag === SystemContants.DELETE_NOT_FLAG) {
    return "正常";
  } else{
    return "不可用";
  }
}
